import PropTypes from 'prop-types';
import React, {Component} from 'react';

//Components
import SummaryHeader from './summaryHeader.jsx';
import SummaryBody from './summaryBody.jsx';

class SummaryReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      loading: false,
      data: [],
    };
  }

  render() {
    const {icon, description, title, tooltip, buttons, POS, truBlue} = this.props;

    return (
      <div className='report-block-container' >
        <SummaryHeader title={title} icon={icon} description={description} tooltip={tooltip} link={buttons[0] ? buttons[0].link : ''}
        />
        <SummaryBody loaded={this.state.loading} columns={this.state.data} POS={POS} buttons={buttons} truBlue={truBlue}/>
      </div>
    );
  }
}

SummaryReport.propTypes = {
  icon: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  description: PropTypes.string.isRequired,
  getData: PropTypes.func,
  title: PropTypes.any.isRequired,
  getColumns: PropTypes.func,
  buttons: PropTypes.any,
  POS: PropTypes.bool.isRequired,
  truBlue: PropTypes.bool,
};

export default SummaryReport;
